module.exports = __webpack_public_path__ + "img/5_97.d9f12503.png";